import React from "react";
import { labels } from "../../../../../localization/labels";
import ChoicePopUp from "../../../../core/ChoicePopUp";
import Table from "../../../../core/Table";
import FileUploader from "../../../../core/FileUploader";
import FileIcon from "react-file-icon";
import { Row, Col, FormGroup, Button, FormLabel } from "react-bootstrap";
import SubmitControl from "../../../../core/SubmitControl";
import TableFormatter from "../../../../core/Table/TableUtils";
import BasicDialog from "../../../../core/BasicDialog/BasicDialog";

const getColumns = (showCheck, onDocumentDownload, editable) => {
  return [
    {
      dataField: "contentType",
      text: labels.contentType,
      formatter: (cellContent, row) => {
        return <FileIcon size="40" extension={row.extension.id} />;
      }
    },
    {
      dataField: "name",
      text: labels.name,
      formatter: TableFormatter.textFormatter
    },
    {
      dataField: "description",
      text: labels.description,
      formatter: TableFormatter.textFormatter
    },
    {
      dataField: "recordedTimeStamp",
      text: labels.dateCreated,
      formatter: TableFormatter.dateFormatter
    },
    {
      dataField: "df1",
      isDummyField: true,
      text: labels.actions,
      formatter: (cellContent, row) => {
        return (
          <>
            {editable ? (
              <Button
                className="fa fa-trash fa-2x buttonStyle"
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  document = row;
                  showCheck();
                }}
              />
            ) : null}
            <Button
              className="fa fa-cloud-download fa-2x buttonStyle"
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                onDocumentDownload(row);
              }}
            />
          </>
        );
      }
    }
  ];
};

var document = undefined;

const Document = ({
  documents,
  onDocumentDownload,
  onDocumentsUpload,
  onDocumentDelete,
  fileUploaderRef,
  documentForUpload,
  onChange,
  disabled,
  validationRules,
  paginationOptions,
  handleTableChange,
  maxLength,
  onSave,
  selectedDocument,
  onRowClick,
  onDocumentEditChange,
  showEditDialog,
  handleCloseEditDialog,
  editable
}) => {
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const choices =
    document === undefined
      ? []
      : [
          { label: labels.no, onClick: handleClose },
          {
            label: labels.yes,
            onClick: () => {
              onDocumentDelete(document);
            }
          }
        ];
  return (
    <>
      {documents !== undefined && (
        <div className="UploadTableTab">
          {editable ? (
            <Row>
              <Col sm="6">
                <Row>
                  <Col sm="4">
                    <FormLabel className="Label">{labels.name}</FormLabel>
                  </Col>
                  <Col sm="8">
                    <FormGroup controlId="name">
                      <SubmitControl
                        type="text"
                        title={labels.name}
                        value={documentForUpload.name}
                        onChange={onChange}
                        placeholder={labels.name}
                        validationRule={validationRules.name}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm="4">
                    <FormLabel className="Label">
                      {labels.description}
                    </FormLabel>
                  </Col>
                  <Col sm="8">
                    <FormGroup controlId="description">
                      <SubmitControl
                        as="textarea"
                        title={labels.description}
                        value={documentForUpload.description}
                        onChange={onChange}
                        placeholder={labels.description}
                        required={true}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              <Col sm="6">
                <FileUploader
                  multiple={false}
                  onUpload={onDocumentsUpload}
                  ref={fileUploaderRef}
                  disabled={disabled}
                />
              </Col>
            </Row>
          ) : null}
          <Table
            data={documents}
            columns={getColumns(handleShow, onDocumentDownload, editable)}
            paginationOptions={paginationOptions}
            onTableChange={handleTableChange}
            //
            onRowClick={onRowClick}
          />
          <ChoicePopUp
            title={labels.areYouSureDelete}
            choices={choices}
            show={show}
            handleClose={handleClose}
          />
          <BasicDialog
            dialogTitle={labels.documentsUpdate}
            show={showEditDialog}
            entity={selectedDocument}
            maxLength={maxLength}
            onSave={onSave}
            onChange={onDocumentEditChange}
            disabled={disabled}
            validationRules={validationRules}
            handleClose={handleCloseEditDialog}
          />
        </div>
      )}
      {}
    </>
  );
};

export default Document;
